/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TextImageContent } from '../../models/text-image-content';
import { TextImageContentApiRespModel } from '../../models/text-image-content-api-resp-model';

export interface ApiMasterTextImageContentEditPost$Params {
      body?: TextImageContent
}

export function apiMasterTextImageContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterTextImageContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TextImageContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTextImageContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TextImageContentApiRespModel>;
    })
  );
}

apiMasterTextImageContentEditPost.PATH = '/api/Master/TextImageContent/Edit';
